module.exports = __webpack_public_path__ + "static/img/StateFoodSafety.833fa7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/StateFoodSafety.png
// module id = 423
// module chunks = 4